<template>
  <Row class="d-flex justify-space-around align-center pl-16">
    <Picture
      :src="src"
      max-width="32"
      max-height="32"
    />
    <span :class="grayText" v-text="lc.faviconName" />
    <ModalDeleteFavicon @onSuccess="$emit('onSuccess')"/>
  </Row>
</template>

<script>
import { Picture, Row, useLocale } from '@locaweb/design-system-vue'
import ModalDeleteFavicon from './ModalDeleteFavicon.vue'

export default {
  name: 'FaviconBox',
  components: {
    Row,
    Picture,
    ModalDeleteFavicon
  },
  props: {
    src: {
      type: String,
      required: true
    }
  },
  setup () {
    const lc = useLocale('site.favicon.faviconCard.faviconBox')
    const grayText = 'text-paragraph-2 gray--text text--scale600 font-weight-medium'

    return { lc, grayText }
  }
}
</script>
